import { shallowEqual, useAppSelector } from 'hooks/reduxHooks'
import { getShouldWaiveLuxPlusJoiningFee } from 'selectors/userCart'

type JoiningFeeData = {
  amount: number
  waived: boolean
}

export type UserMultiCartSubscriptionItemData = {
  loading: false;
  error: undefined;
  joiningFee: JoiningFeeData
  itemTotals: App.Checkout.ItemViewTotals;
} | {
  loading: boolean;
  error: any;
  joiningFee: JoiningFeeData | undefined
  itemTotals: App.Checkout.ItemViewTotals | undefined;
}

function useUserMultiCartSubscriptionItemData(): UserMultiCartSubscriptionItemData {
  const {
    offers,
    loading,
    error,
    waiveJoiningFee,
  } = useAppSelector(state => ({
    offers: state.luxPlus.products.subscription.offers,
    loading: state.luxPlus.products.subscription.fetching,
    error: state.luxPlus.products.subscription.error,
    waiveJoiningFee: getShouldWaiveLuxPlusJoiningFee(state),
  }), shallowEqual)

  const offer = offers?.find(o => o.joinFeeWaived === waiveJoiningFee)

  if (offer) {
    const itemTotals: App.Checkout.ItemViewTotals = {
      price: offer.price,
      memberPrice: 0,
      value: offer.price + offer.joinFee,
      taxesAndFees: 0,
      surcharge: 0,
      memberValue: 0,
      extraGuestSurcharge: 0,
    }

    return {
      loading: false,
      error: undefined,
      joiningFee: {
        amount: offer.joinFee,
        waived: waiveJoiningFee,
      },
      itemTotals,
    }
  }

  return {
    loading,
    error,
    joiningFee: undefined,
    itemTotals: undefined,
  }
}

export default useUserMultiCartSubscriptionItemData
